const config = {
  api_url: window.env?.REACT_APP_API_URL ?? "http://localhost:8080",
  basePath: "fchub",
  login_cookie: window.env?.REACT_APP_LOGIN_COOKIE ?? "sl2sta_dev",

  //labor table roles
  ROLE_FC_VP: "FcVPS",
  ROLE_FC_SUPER_ADMIN: "FcSuperAdmin",
  ROLE_FC_ADMIN: "FcAdmin",
  ROLE_FC_DISRTICT_MGR: "FcDistrictMgr",
  ROLE_FC_CITY_MGR: "FcCityMgr",
  ROLE_FC_STORE_MGR: "FcStoreManager",
  ROLE_FC_OPS_MGR: "FcOpsMgr",
  ROLE_FC_ESTIMATOR: "FcEstimator",
  ROLE_FC_SALES_REP: "FcSalesRep",
  ROLE_FC_OTHER_EE: "FcOtherEE",
  ROLE_FC_TECH_REP: "FcTechRep",
  ROLE_FC_NA: "FcNA",

  admin_role: "NAESearchAdmin",
  executive_role: "NAESearchAccountExec",
  admin_label: "admin",
  guest_label: "guest",
  executive_label: "accountExecutive",
  naCustomer_label: "nacustomer",
  nacsCustomer_label: "nacscustomer",
  break_points: {
    small: 576,
    medium: 768,
    large: 992,
    extraLarge: 1200,
    extraExtraLarge: 1400,
  },
  detailTabsId: "#details-tabs",
  accountExecutiveTabId: "#account-executive-tab",
  customerInfoTabId: "#customer-info-tab",
  additionalInfoTabId: "#additional-client-info-tab",
  userInfoCookie: "userInfo",
};

export default config;
